import { useState } from "react";
import { Card, ListGroup, Spinner } from "olive-react-myoneui";
import { cameraIcon } from "../../../constants/icons";

const ProfileCard = ({ title, onFileSelect, multiple = false, image }) => {
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    setLoading(true);

    // Always send an array of files
    if (onFileSelect) {
      onFileSelect(files);
    }

    // Create preview URLs
    const urls = files.map((file) => URL.createObjectURL(file));
    setPreviews(urls);

    setLoading(false);
  };

  return (
    <Card className="upload-profile-block">
      <Card.Body>
        <div className="upload-img-circle">
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : previews.length > 0 ? (
            previews.map((src, idx) => (
              <img key={idx} src={src} alt={`preview-${idx}`} />
            ))
          ) : image ? (
            <img src={image} alt="existing-preview" />
          ) : (
            cameraIcon
          )}
          <input
            type="file"
            accept="image/*"
            multiple={multiple}
            onChange={handleFileChange}
          />
        </div>
        <div className="card-info">
          <Card.Title as="h5">{title}</Card.Title>
          <ListGroup as="ul" className="card-list">
            <ListGroup.Item as="li">Aspect Ratio: 16:9</ListGroup.Item>
            <ListGroup.Item as="li">
              Recommended size: 3840x2160 or 1920x1080 pixels
            </ListGroup.Item>
          </ListGroup>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProfileCard;